export default {
  setServices: (state, payload) => { state.services = payload },
  setService: (state, payload) => { state.service = payload },
  setSubservice: (state, payload) => { state.subservice = payload },
  setSuppliers: (state, payload) => { state.suppliers = payload },
  setSupplier: (state, payload) => { state.supplier = payload },
  setProjects: (state, payload) => { state.projects = payload },
  setClients: (state, payload) => { state.clients = payload }
}